module.exports = __webpack_public_path__ + "img/卷帘控制.701e010f.png";